import sdl from '@jds/react-generated-sdl/JDSAvatarV2Information';
import type { JDSAvatarV2InformationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2InformationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'icon',
    placement = 'bottom-right',
    size = 'medium',
    disabled = false,
    ariaLabel = 'Avatar with Information Badge',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, placement, size, disabled, ariaLabel, ...rest },
    'JDSAvatarV2Information',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2Information = withLogic(
  Component
) as React.FC<JDSAvatarV2InformationProps> & { slotName?: string };

AvatarV2Information.displayName = 'AvatarV2Information';
AvatarV2Information.slotName = 'jds_avatar_v_2_information';

export { AvatarV2Information, type JDSAvatarV2InformationProps };
